/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Status_1Inputs */

const en_mk_tb_example_status_1 = /** @type {(inputs: Mk_Tb_Example_Status_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

const id_mk_tb_example_status_1 = /** @type {(inputs: Mk_Tb_Example_Status_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikerjakan`)
};

/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Mk_Tb_Example_Status_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_status_1 = /** @type {((inputs?: Mk_Tb_Example_Status_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Status_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_status_1(inputs)
	return en_mk_tb_example_status_1(inputs)
});